module.exports = "<section class=\"container mat-typography\">\r\n  <div style=\"display: flex\">\r\n    <h2 class=\"title\">Loan Programs and Products</h2>\r\n    <button mat-mini-fab type=\"button\" class=\"program-button\" (click)=\"openProgramAddDialog()\"><i class=\"material-icons\">&#xE145;</i></button>\r\n  </div>\r\n</section>\r\n<br/>\r\n<app-program-list ></app-program-list>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/loanprograms.component.html
// module id = ../../../../../src/app/loanprograms/loanprograms.component.html
// module chunks = main